const lbFiveStarRating = angular.module('app.lbFiveStarRating', []);

lbFiveStarRating.controller('lbFiveStarRatingController', require('./lbFiveStarRatingController'));
lbFiveStarRating.directive('lbFiveStarRating', require('./lbFiveStarRatingDirective'));

export default lbFiveStarRating;



// WEBPACK FOOTER //
// ./src/components/lbFiveStarRating/index.js